import React, { useState, useRef } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { Modal, Button, Form, Col, Row } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import JoditEditor from "jodit-react";

export default function CreateTestimonials() {
  const navigate = useNavigate();
  const editor = useRef(null);
  const [name, setName] = useState("");
  const [name_bio, setNameBio] = useState("");
  const [category, setCategory] = useState("");
  const [image, setImage] = useState(null);
  const [testimonial, setTestimonial] = useState("");
  const [isactive, setIsActive] = useState(1);
  const [sequence, setSequence] = useState(null);
  const [showCreateModal, setShowCreateModal] = useState(false);

  const handleImage = (e) => {
    setImage(e.target.files[0]);
  };

  const handleCreate = async (e) => {
    e.preventDefault();
    setShowCreateModal(false);

    if (
      !name ||
      !name_bio ||
      !category ||
      !image ||
      !testimonial
    ) {
      toast.error("Missing required parameters.", {
        position: "top-right",
        autoClose: 1000,
        theme: "colored",
      });
      return;
    }

    const formData = new FormData();
    formData.append("name", name);
    formData.append("name_bio", name_bio);
    formData.append("category", category);
    formData.append("image", image);
    formData.append("testimonial", testimonial);
    formData.append("isactive", isactive);
    formData.append("sequence", sequence);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}testimonials/inserttestimonials`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 200) {
        toast.success("Testimonial created successfully", {
          position: "top-right",
          autoClose: 1500,
          theme: "colored",
        });
        setTimeout(() => {
          navigate("/testimonialsList");
        }, 2000);
      } else {
        toast.error("Testimonial was not added", {
          position: "top-right",
          autoClose: 1000,
          theme: "colored",
        });
      }
    } catch (err) {
      console.error(err);
      toast.error("An error occurred while creating the testimonial.", {
        position: "top-right",
        autoClose: 1000,
        theme: "colored",
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowCreateModal(true);
  };

  return (
    <>
      <div className="container mt-4">
        <div className="form-card">
          <div className="form-card-header">
            Add New Testimonial
          </div>
          <div className="form-card-body">
            <Form onSubmit={handleSubmit}>
              <Row className="mb-3">
                <Form.Group as={Col} controlId="name">
                  <Form.Label>Name:</Form.Label>
                  <Form.Control
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    maxLength={100}
                  />
                </Form.Group>

                <Form.Group as={Col} controlId="name_bio">
                  <Form.Label>Name Bio:</Form.Label>
                  <Form.Control
                    type="text"
                    value={name_bio}
                    onChange={(e) => setNameBio(e.target.value)}
                    maxLength={100}
                  />
                </Form.Group>
              </Row>

              <Row className="mb-3">
                <Form.Group as={Col} controlId="category">
                  <Form.Label>Category:</Form.Label>
                  <Form.Control
                    type="text"
                    value={category}
                    onChange={(e) => setCategory(e.target.value)}
                    maxLength={100}
                  />
                </Form.Group>

                <Form.Group as={Col} controlId="image">
                  <Form.Label>Image:</Form.Label>
                  <Form.Control
                    type="file"
                    onChange={handleImage}
                  />
                </Form.Group>
              </Row>

              <Row className="mb-3">
                <Form.Group as={Col} md={6} controlId="sequence">
                  <Form.Label>Sequence:</Form.Label>
                  <Form.Control
                    type="number"
                    value={sequence}
                    onChange={(e) => setSequence(e.target.value)}
                  />
                </Form.Group>
              </Row>

              <Form.Group className="mb-3" controlId="testimonialEditor">
                <Form.Label>Testimonial Content:</Form.Label>
                <JoditEditor
                  ref={editor}
                  value={testimonial}
                  onChange={newContent => {
                  if (newContent !== testimonial) {
                    setTestimonial(newContent);
                  }
                }}
                />
              </Form.Group>

              {/* Toggle Switch for Is Active */}
              <div className="toggle-switch">
                <input
                  type="checkbox"
                  checked={isactive === 1}
                  onChange={(e) => setIsActive(e.target.checked ? 1 : 0)}
                />
                <span className="toggle-switch-label">Is Active</span>
              </div>

              {/* Form Actions */}
              <div className="form-actions">
                <button type="submit" className="btn-gradient-success">
                  Create Testimonial
                </button>
                <Link to="/testimonialsList" className="btn-back-link">
                  ← Back to List
                </Link>
              </div>
            </Form>
          </div>
        </div>

        <ToastContainer />

        <Modal show={showCreateModal} onHide={() => setShowCreateModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Add New Testimonial</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to create this testimonial?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowCreateModal(false)}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleCreate}>
              Add New Testimonial
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}